import "../../../css/bem/_quick-basket.scss";
import panelUpdater from "@remarkablenet/panel-updater";
import { getQuickbasketHTML, getQuickBasketCount, getBasketTotal } from "./quick-basket-services";
import { removeFromBag, increaseQuantityBasket, decreaseQuantityBasket } from "../bag/bag-services";
import * as CSSTH from "../css-transition-helper/css-transition-helper";
import { gtag } from '../utility-functions/utility-functions';
import { trackQuickViewEvent } from '../bloomreach/bloomreach';
import { disableScroll, enableScroll } from '../utility-functions/utility-functions';
import { showSolidHeader, showGlassHeader } from '../../global';
import { isTouch } from '@remarkablenet/rcm-utils';
import { dispatchEventWrapper } from '../event/event';

let loadTriggered = false;

const DEFAULTS = {
  quickBasket: ".quick-basket",
  quickBasketContent: ".quick-basket__content",
  quickBasketCount: ".js-quick-basket-count",
  basketTotal: ".js-basket-total",
  basketTotalContent: ".basket-total__content",
};

const modifyContent = (elm, html) => {
  elm.innerHTML = html;
};

const scrollbarWidth = window.innerWidth - document.body.clientWidth + "px";

const basketShown = () => {
  document.querySelector("html").classList.add("quick-basket-active");
  // document.body.style.overflow = 'hidden';
  // document.body.style.marginRight = scrollbarWidth;
  // (document.querySelector('.header-sticky') as HTMLElement).style.paddingRight = scrollbarWidth;

  gtag('event', 'quick_basket_show', {
    'triggered': 'true',
  });

    trackQuickViewEvent({
        type: "cart"
    });
};

const basketHidden = () => {
  // document.body.style.removeProperty('overflow');
  // document.body.style.marginRight = '0';
  // (document.querySelector('.header-sticky') as HTMLElement).style.paddingRight = '0';
};

const applyQuickBasketOpenScrollLock = (fromPreviewPath = false) => {
  if (!isTouch()) {
    showSolidHeader();
    disableScroll();
    return;
  }
  if (document.body.classList.contains("header-is-revealed")) {
    disableScroll();
    return;
  }
  if (fromPreviewPath) {
    disableScroll();
  }
};

const closeQuickBasket = (elm) => {
  basketHidden();
  CSSTH.deactivate(elm);
};

const loadQuickBasket = (elm) => {
  if (loadTriggered) return;
  loadTriggered = true;
  const panel = elm.querySelector(".panel-updater");
  document.querySelectorAll(".js-open-quick-basket").forEach((trigger) =>
    trigger.addEventListener("click", (e) => {
      if (window.innerWidth < 768) {
        return;
      } else {
        e.preventDefault();
        updateQuickBasket(panel);
        applyQuickBasketOpenScrollLock(false);

        basketShown();
        CSSTH.activate(elm);
        setupCloseQuickbasket(elm);
        // loadOverlay(elm);
      }
    })
  );
};

const loadQuickBasketAddProduct = (elm, timeout?: NodeJS.Timeout) => {
  const panel = elm.querySelector(".panel-updater");
  if (timeout) elm.onmouseenter = () => clearTimeout(timeout);
  if (elm.classList.contains("is-active")) {
    updateQuickBasket(panel);
    return;
  }
  applyQuickBasketOpenScrollLock(true);
  basketShown();
  CSSTH.activate(elm);
  updateQuickBasket(panel);
  setupCloseQuickbasket(elm);
};

const updateQuickBasket = async (elm, count = -1) => {
  if (count === -1 && elm.classList.contains("panel-updater")) {
    const html = await panelUpdater(elm, getQuickbasketHTML());
    modifyContent(elm, html);
    setupQuickbasketIncreaseQuantity(elm);
    setupQuickbasketDecreaseQuantity(elm);
    setupQuickbasketDelete(elm);
    setupCloseQuickbasket(elm);
  }
  updateQuickBasketCount(count, true);
  updateBasketTotal(true);
};

const quickShowQuickbasket = (elm: HTMLElement) => {
  // const closeTimeout = setTimeout(() => {
  //   closeQuickBasket(elm);
  // }, 3000);

  loadQuickBasketAddProduct(elm);
};

const setupQuickbasketDelete = (elm) => {
  elm.querySelectorAll(".js-quick-basket-item-remove").forEach((item) => {
    const shoppingBasketId = Number(item.dataset.pid);

    item.addEventListener("click", (e) => {

      const container = item.closest('.quick-basket-item__details');
      const val = container.querySelector('.quick-basket-item__price').textContent;
      const code = item.dataset.pid;
      const title = container.querySelector('.quick-basket-item__title').textContent.trim();

      gtag('event', 'remove_from_cart', {
        'value': val,
        'item_id': code,
        'item_name': title
      });

      e.preventDefault();
      quickbasketDelete(shoppingBasketId, elm, item.closest(".quick-basket-item"));
    });
  });
};


const setupQuickbasketIncreaseQuantity = (elm) => {
  elm.querySelectorAll(".js-quick-basket-item-increase").forEach((item) => {
    const shoppingBasketId = Number(item.dataset.pid);
    item.addEventListener("click", (e) => {
      e.preventDefault();
      quickbasketChangeQuantity(shoppingBasketId, item.closest(".quick-basket-item"), false);
    });
  });
};

const setupQuickbasketDecreaseQuantity = (elm) => {
  elm.querySelectorAll(".js-quick-basket-item-decrease").forEach((item) => {
    const shoppingBasketId = Number(item.dataset.pid);

    item.addEventListener("click", (e) => {
      e.preventDefault();
      quickbasketChangeQuantity(shoppingBasketId, item.closest(".quick-basket-item"), true);
    });
  });
};

const handleQuickBasketHide = (e) => {
  document.querySelector(".quick-basket__content").classList.remove("is-active");
  document.querySelector(".quick-basket__content").classList.remove("is-visible");
  document.querySelector("html").classList.remove("quick-basket-active");

  gtag('event', 'quick_basket_hide', {
    'triggered': 'true',
  });

  enableScroll();
  showGlassHeader(500);
  basketHidden();
};

const setupCloseQuickbasket = (elm) => {
  elm.querySelectorAll(".js-close-quick-basket").forEach((item) => {
    item.removeEventListener("click", handleQuickBasketHide);
    item.addEventListener("click", handleQuickBasketHide);
  });
};

// const loadOverlay = (elm) => {
//     console.log('loadOverlay');
//     // const overlay = document.createElement('div');
//     // overlay.classList.add('quick-basket__overlay');
//     // document.body.appendChild(overlay);
//     document.body.addEventListener('click', (e) => {
//         closeQuickBasket(elm);
//         // overlay.remove();
//     });
// };

export const quickbasketDelete = (id, elm, item) => {
  removeFromBag(id).then(async (r) => {
    if (r.success) {
      var reset = false;
      let count = await getQuickBasketCount();
      if (elm.classList.contains("panel-updater")) {
        item.classList.add("quick-basket-item--fade");
        item.addEventListener("transitionend", () => {
          if (!reset) {
            reset = true;
            if (elm.classList.contains("panel-updater")) {
              item.remove();
              updateQuickBasket(elm, !count ? -1 : count);
            }
          }
        });
      } else {
        if (!count) location.href = "/basket";
        else elm.remove();
      }
      updateQuickBasket(elm);
    }
  });
};

export const quickbasketChangeQuantity = (id, elm, isDecrease) => {
  let parent = elm,
    input = parent.querySelector(".js-hidden-qty"),
    currentQuantity = parseInt(input.value),
    newQuantity = isDecrease ? currentQuantity - 1 : currentQuantity + 1,
    action = isDecrease ? decreaseQuantityBasket(id, currentQuantity) : increaseQuantityBasket(id, currentQuantity),
    removeBtn = parent.querySelector(".basket-item__quantity-btn.js-quick-basket-item-remove"),
    decreaseBtn = parent.querySelector(".basket-item__quantity-btn.js-quick-basket-item-decrease");

  action.then(async (r) => {
    ResetErrors();

    if (r.success) {
      let count = await getQuickBasketCount();
      input.value = newQuantity;
      parent.querySelector(".js-basket-qty").innerHTML = newQuantity;

      if (newQuantity >= 2) {
        decreaseBtn.classList.remove("hidden");
        removeBtn.classList.add("hidden");
      } else {
        decreaseBtn.classList.add("hidden");
        removeBtn.classList.remove("hidden");
      }

      updateQuickBasket(elm, !count ? -1 : count);
    } else {
      var error = document.querySelector(".js-quick-basket-errors");
      var doc = document.createDocumentFragment();
      for (var i = 0; i < r.errors.length; i++) {
        var err = error.cloneNode() as HTMLElement;
        err.innerHTML = r.errors[i].description;
        err.classList.remove("hidden");
        doc.appendChild(err);
      }
      error.replaceWith(doc);
    }
  });
};

const ResetErrors = () => {
  document.querySelectorAll(".js-quick-basket-errors").forEach((err, index) => {
    if (index) err.remove();
    else {
      err.innerHTML = "";
      err.classList.add("hidden");
    }
  });
};

// preview quickbasket
export const previewQuickbasket = (quickBasketContent = DEFAULTS.quickBasketContent, quickBasket = DEFAULTS.quickBasket) => {
  const QUICK_BASKET = document.querySelector(quickBasket);
  const QUICK_BASKET_ELEMENT = QUICK_BASKET.querySelector(quickBasketContent);
  quickShowQuickbasket.bind(null, QUICK_BASKET_ELEMENT)();
};

// quick basket count
export const updateQuickBasketCount = async (count = -1, cacheBuster = false) => {
  if (count === -1) count = await getQuickBasketCount(cacheBuster);
  if (!count || typeof count !== "number") count = 0;
  document.querySelectorAll(DEFAULTS.quickBasketCount).forEach((elm) => {
    modifyContent(elm, count > 0 ? count : "");
  });
};

// basket Total
export const updateBasketTotal = async (cacheBuster = false) => {
  let total = await getBasketTotal(cacheBuster);

  document.querySelectorAll(DEFAULTS.basketTotal).forEach((elm) => {
    modifyContent(elm, total);
  });

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'basket_total_updated',
    'basket_total_cs': total
  });

  dispatchEventWrapper(document, 'rc-basket-updated', {});
};

// quick basket init
export const init = (quickBasket = DEFAULTS.quickBasket, quickBasketContent = DEFAULTS.quickBasketContent) => {
  const QUICK_BASKET: HTMLElement = document.querySelector(quickBasket);
  const QUICK_BASKET_ELEMENT = QUICK_BASKET.querySelector(quickBasketContent);
  let debounce;
  QUICK_BASKET.onmouseenter = () => {
    if (QUICK_BASKET_ELEMENT.classList.contains("is-active")) return;
    debounce = window.setTimeout(() => {
      loadQuickBasket(QUICK_BASKET_ELEMENT);
    }, 300);
  };

  QUICK_BASKET.onmouseleave = () => {
    window.clearTimeout(debounce);
  };

  return {
    loadQuickbasket: () => loadQuickBasket.bind(null, QUICK_BASKET_ELEMENT)(),
  };
};
